import axios from "axios"

const ax = axios.create({
    baseURL: window.BOOKMARK_CONF.api_url,
    responseType: 'json',
    responseEncoding: 'utf8',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
    }
});

const ID_RE = /^IT-ENI-([A-Z]+)(\d{4})-(\d{6,10})$/;
const ID_HASH_RE = /([A-Z]+)(\d+)([A-Z])(\d+)/g;

// AV1G2064AV1G2074ST1G41ST1G52ST1G56FT1K1566FT1K1567
// ---- internal methods ----

function countToChar(num /* Number */) {
    const zero = 'A'.codePointAt(0);

    return String.fromCodePoint(zero + num)
}

function charToCount(char /* String[1] */) {
    const zero = 'A'.codePointAt(0);

    return char.codePointAt(0) - zero
}

function remove0(str /* String */) {
    let idx = 0;

    for (const char of str) {
        if(char !== '0')
            break;

        idx++
    }

    return str.substring(idx, str.length)
}

const BookmarksApi = () => ({

    retrieveList(ids /* Array */) {
        const query = `id_string:(${ids.join(' OR ')})`;

        return ax.post('/search', {
            query: query,
            filters: [],
            fields: [],
            facets: [],
            sort: {
                field: 'archiveType_string',
                order: 'asc'
            },
            paging: { start: 0, limit: ids.length }
        }, {
            transformResponse(data) {
                if(typeof data === 'string') {
                    data = JSON.parse(data)
                }

                return data['documents'] || [];
            }
        })
    },

    encodeIDHash(ids /* Array */) {
        if(ids === undefined || ids === null || ids.length === 0)
            return "";

        return ids.map(id => {
            const match = id.match(ID_RE);

            const parts = {
                arch:  match[1],
                prog1: remove0(match[2]),
                prog2: remove0(match[3]),
                fill:  countToChar(match[3].length)
            };

            return `${parts.arch}${parts.prog1}${parts.fill}${parts.prog2}`
        }).join('')
    },

    decodeIDHash(hash /* String */) {
        if (hash === undefined || hash === null || hash.length < 5)
            return [];

        hash = hash.substring(1, hash.length);

        const result = [];

        let cid;
        do {
            cid = ID_HASH_RE.exec(hash);
            if (cid) {
                result.push(`IT-ENI-${cid[1]}${cid[2].padStart(4, '0')}-${cid[4].padStart(charToCount(cid[3]), '0')}`)
            }
        } while (cid);

        return result
    }

});

export default BookmarksApi();